import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";
import type {IRewardStat} from "modules/actions/rewardStats";
import {BadgeType} from 'modules/enums';

const defaultReward: IRewardStat = {
	reward: BadgeType.STREAK_5,
	earnedPercentage: 0,
	rarity: "Rare",
	color: "#a442f1",
};
export const getRewardsStore = (store: TStore) => store.rewards;

export const getRewardsStats = createSelector([getRewardsStore], (store) => store.rewards);

export const getRewardStatsByName = createSelector(
	[getRewardsStats],
	(rewards) => (reward: BadgeType) => rewards.find((it) => it.reward === reward) || defaultReward
);
